export default __webpack_public_path__ + "4bf5c8b0a1bb98cf948e9e9d9db2781c.png";